<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My teacher said there’s a book but I don’t know what it’s called or the ISBN</h1>
			<div>
				<email-form
						subject="My teacher said there’s a book but I don’t know what it’s called or the ISBN"
						:body="email_body"
						on-success-url="/help?#/submitted"
						edit-body
						destination-key="ge"
				></email-form>
			</div>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';

	export default {
		name: "ThereIsBookGotNoIsbn",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				course_id: '',
			}
		},

		computed: {
			email_body() {
				return `Hello, My professor said there is a book for course ${this.course_id} but I don’t know what book it is. Can you have someone talk to my professor so I can buy my book?`;
			},
		},

		mounted() {
			this.course_id = parseInt(this.$route.params['course_id']);
		}
	}
</script>

<style scoped>

</style>